import React, {useEffect, useState} from "react";
import CardForm from "../../components/form/CardForm";
import fields from "./config/MachineModelSelectionFormConfig";
import utils from "../../helpers/utils";
import {Actions} from "../../../client/Actions";
import { useTranslation } from 'react-i18next';

const MachineModelSelectionSection = ({
                                     setSelectedMachineModel,
                                     format,
                                     setLoader,
                                     notIn,
                                     access,
                                     onSaved
                                 }) => {

    const { t } = useTranslation();

    const [machineModels, setMachineModels] = useState()


    const loadMachines = () => {
        Actions.get("machine-model", machineModelsLoaded)
    };

    const machineModelsLoaded = (data) => {
        setMachineModels(data.filter(m => m.formatPartsCount > 0))
    };


    const customSave = (form) => {
        console.log("selected machine model: ", form.machineModel);
        setSelectedMachineModel(form.machineModel);
        setLoader(false);
    };


    const [dictionaries, setDictionaries] = useState();

    useEffect(() => {
        if (format && format.machineTypes && machineModels) {
            const tmp = {};
            tmp["enums/machineType"] = format.machineTypes.filter(type => !format.machineModels.some(m => m.machineType === type));
            tmp["machineModel"] = machineModels;
            setDictionaries(tmp);
        } else if (machineModels) {
            const tmp = {};
            tmp["enums/machineType"] = utils.unique(machineModels.map(m => m.machineType));
            tmp["machineModel"] = machineModels;
            setDictionaries(tmp);
        }
    }, [format, machineModels]);

    useEffect(loadMachines, [notIn])

    return (
        <>
            {dictionaries && access &&
                <CardForm
                    title={t("forms.choose_machine_model")}
                    setLoader={setLoader}
                    fields={fields(t)}
                    width={12}
                    dictionaries={dictionaries}
                    className={"mx-0 px-0"}
                    customSave={customSave}
                    saveButton={t("forms.start_configuration")}
                    reverseButtons={true}
                    postSaved={onSaved}
                />
            }
        </>
    );
};

export default MachineModelSelectionSection;
